<template>
  <div
    class="snippet"
    :style="
      topBarView
        ? 'padding: 2px 10px !important; border-radius: 8px !important; background-color: unset !important; border: unset !important; flex-direction: row !important; align-items: center !important; width: 100% !important; box-shadow: none !important;'
        : ''
    "
  >
    <!-- <CancelSession
      v-if="!sessionIsMatched"
      :user="user"
      :slotData="nextSession"
      :boxHeight="'height: 115px;'"
      :nextSession="nextSession"
      :quickCancel="true"
      :sessionTime="getSessionTimes"
      @refreshNextOrCurrentSession="refreshNextOrCurrentSession"
      @hardRefreshTimerAndNextSession="hardRefreshTimerAndNextSession"
      parentName="SessionTimer"
    /> -->
    <div v-if="bookingOrViewing && !topBarView" class="upcoming" :style="topBarView ? 'font-size: 12px !important; margin-right: auto !important;' : ''">
      {{ notifierHeaderText }}
    </div>
    <div class="datetime">
      <span v-if="!topBarView" class="time">{{ getSessionTimes }}</span>
      <span v-if="bookingOrViewing && !topBarView" class="date" :style="topBarView ? 'font-size: 18px !important; background-color: unset !important;' : ''">{{ getSessionDates }}</span>
    </div>
    <div class="details" v-if="sessionIsMatched">
      <a :href="`/profile/${partnerMetadata.ID}`" class="img" :style="topBarView ? 'display: flex !important;' : ''">
        <ik-image
          loading="lazy"
          :transformation="[{ height: 60, width: 60 }]"
          v-if="partnerMetadata.profileImageUrl"
          :src="partnerMetadata.profileImageUrl"
          class="picture"
          :style="topBarView ? 'width: 34px !important; height: 34px !important;' : ''"
        />
        <div v-else class="picture smallBorder" :style="topBarView ? 'width: 34px !important; height: 34px !important;' : ''">
          <IconBase icon-name="profile" iconColor="#333" viewBox="0 0 32 32" width="100%" height="100%" strokeWidth="0px"><IconProfileImg /></IconBase>
        </div>
      </a>
      <a :href="`/profile/${partnerMetadata.ID}`" class="name" :class="topBarView ? 'unmatchedName--topBarView' : ''">{{ partnerMetadata.displayName }}</a>
      <span v-if="topBarView" class="topBarTime">{{ getSessionDates }} — {{ getSessionTimes }}</span>
      <!-- <a v-if="showJoinLink && bookingOrViewing" :href="joinSessionLink" class="join" :style="joinStyle">Join</a> -->
      <a :href="joinSessionLink" v-if="showJoinLink && bookingOrViewing" :style="joinStyle" class="join">Join</a>
    </div>
    <div class="details unmatched-details" v-else>
      <div class="name unmatched-name" :class="topBarView ? 'unmatchedName--topBarView' : ''">Not yet matched...</div>
      <span v-if="topBarView" class="topBarTime">{{ getSessionDates }} — {{ getSessionTimes }}</span>
      <!-- <a v-if="showJoinLink && bookingOrViewing" :href="joinSessionLink" class="join" :style="joinStyle">Join</a> -->
      <a :href="joinSessionLink" v-if="showJoinLink && bookingOrViewing" :style="joinStyle" class="join">Join</a>
    </div>
    <div v-if="showJoinLink && !bookingOrViewing">
      <!-- <a :href="joinSessionLink" class="join" :style="joinStyle">Join</a> -->
      <a :href="joinSessionLink" :style="joinStyle" class="join">Join</a>
    </div>
    <div v-if="!shrinkedView && bookingOrViewing && !topBarView" @click="openGuidelines" class="review-guidelines review-custom">ℹ Review session guidelines</div>
  </div>
</template>

<script>
import { format } from "date-fns";
import IconBase from "../../components/IconBase";
import IconProfileImg from "../../components/SVG/IconProfileImg";

import { formatSlotDate } from "../../utilities/dateFormatter";
import { SESSION_LENGTH_MS } from "../../constants_calendar";

export default {
  name: "TimerSessionSnippet",
  props: ["userId", "prefers24Hours", "nextSession", "sessionIsMatched", "showJoinLink", "bookingOrViewing", "notifierHeaderText", "topBarView", "shrinkedView"],
  components: {
    // CancelSession,
    IconBase,
    IconProfileImg,
  },
  computed: {
    joinSessionLink() {
      return "/session/" + this.nextSession.SID;
    },
    getSessionTimes() {
      const startTime = this.nextSession.dateTimeMS;
      const endTime = startTime + SESSION_LENGTH_MS;
      return formatSlotDate(startTime, this.prefers24Hours) + "-" + formatSlotDate(endTime, this.prefers24Hours);
    },
    getSessionDates() {
      return format(this.nextSession.dateTimeMS, `MMMM d, y`);
    },
    partnerMetadata() {
      const partnerID = this.nextSession ? this.nextSession.partner.metadata.ID : null;
      if (partnerID) {
        const partner = this.$store.state.calendarUsers.users[partnerID];
        if (partner && partner.metadata) {
          return {
            profileImageUrl: partner.metadata.profileImageUrl,
            displayName: partner.metadata.displayName,
            ID: partner.metadata.ID,
          };
        }
      }
      return {
        profileImageUrl: null,
        displayName: null,
      };
    },
    joinStyle() {
      let styles = "";
      if (this.topBarView && this.$windowWidth > 800) {
        styles = "margin-left: 22px !important; font-size: 18px !important; line-height: 26px !important;";
      } else if (this.topBarView && this.$windowWidth <= 800) {
        styles = "margin-left: 22px !important; font-size: 15px !important; line-height: 26px !important;";
      }
      return styles;
    },
  },
  methods: {
    openGuidelines() {
      this.$store.dispatch("modals/setModalState", {
        modal: "miniGuidelines",
        newState: true,
      });
    },
  },
};
</script>

<style scoped>
.review-guidelines {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  font-size: 16px;
  border-radius: 360px;
  background-color: #ffffff;
  margin-top: 8px;
  font-weight: 600 !important;
  box-shadow: rgb(15 15 15 / 10%) 0px 0px 0px 1px, rgb(15 15 15 / 10%) 0px 2px 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.review-custom {
  border: 1px solid #ffffff;
  padding: 4px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  box-shadow: unset;
  text-decoration: underline;
  border-radius: unset;
  text-underline-offset: 4px;
  text-decoration-color: #424242;
  background-color: transparent;
  border-color: transparent;

  font-size: 14px;
}
.review-guidelines:hover {
  color: #666;
  text-decoration-color: #777;
}
.topBarTime {
  margin-right: auto;
  padding-top: 0;
  padding-bottom: 0;
  padding: 0 10px;
  line-height: 20px;
  display: block;
  justify-content: center;
  margin-left: 16px;
  text-align: center;
  border-radius: 360px;
  padding: 5px 10px;
  font-weight: 800;
  font-weight: 700;
  font-size: 14px !important;
  align-items: center;
  border-top: 0;
  border: 1px solid #eaeaea;
  color: #2d2d2d;
  background-color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  /* text-transform: uppercase; */
  text-overflow: ellipsis;
  box-sizing: border-box;
  box-shadow: 0 1px 4px 0 rgb(206 206 206/42%) !important;
  border: unset;
  color: var(--calendar-box-time-color);
  background: var(--calendar-box-time-background);
  border-width: var(--calendar-box-time-border-width);
  border-color: var(--calendar-box-time-border-color);
  border-radius: var(--calendar-box-time-border-radius);
}
</style>
